import React, { useState } from 'react'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Autocomplete from '@mui/material/Autocomplete'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AddIcon from '@mui/icons-material/Add'
import ClearIcon from '@mui/icons-material/Clear'
import { clearFields, createConfig } from './Functions'
import { useCQuery } from '../../Services'

const CreateConfigSection = ({ configs, loggedInUser }) => {
  const [configName, setConfigName] = useState('')
  const [configAgencyId, setConfigAgencyId] = useState(
    loggedInUser.role === 'siapAdmin' ? '' : (loggedInUser?.allAgencies?.[0]?._id || loggedInUser?.agency?._id)
  )
  const { data: agencies = [], isSuccess: isSuccessAgencies } = useCQuery('agencies')

  if (!isSuccessAgencies) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  const isAdmin = loggedInUser.role === 'siapAdmin'

  return (
    <Paper
      elevation={0}
      sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}
    >
      <Typography variant='subtitle2' sx={{ mb: 1.5, fontWeight: 600 }}>
        Nuova Configurazione
      </Typography>
      <Stack direction='row' spacing={2} alignItems='flex-start'>
        {isAdmin
          ? (
            <Autocomplete
              options={agencies.map(a => a._id)}
              value={configAgencyId || null}
              onChange={(_, newValue) => setConfigAgencyId(newValue || '')}
              renderInput={(params) => (
                <TextField {...params} label='Agency ID' size='small' required />
              )}
              sx={{ minWidth: 240 }}
              freeSolo
              size='small'
            />
          )
          : (
            <TextField
              label='Agency ID'
              value={loggedInUser?.allAgencies?.[0]?._id || loggedInUser?.agency?._id || ''}
              disabled
              size='small'
              sx={{ minWidth: 240 }}
            />
          )}

        <TextField
          label='Nome Config'
          value={configName}
          onChange={(e) => setConfigName(e.target.value)}
          size='small'
          disabled={!isAdmin}
          sx={{ minWidth: 200 }}
        />

        <Button
          variant='contained'
          startIcon={<AddIcon />}
          onClick={() => createConfig(configName, configAgencyId, configs, loggedInUser, setConfigAgencyId, setConfigName)}
          disabled={!isAdmin}
          sx={{ textTransform: 'none', fontWeight: 600, whiteSpace: 'nowrap' }}
        >
          Crea Config
        </Button>

        <Button
          variant='outlined'
          startIcon={<ClearIcon />}
          onClick={() => clearFields(setConfigAgencyId, setConfigName)}
          sx={{ textTransform: 'none', fontWeight: 500, whiteSpace: 'nowrap' }}
        >
          Pulisci
        </Button>
      </Stack>
    </Paper>
  )
}

export default CreateConfigSection
